/**
 * Utility per generare URL SEO-friendly per i necrologi
 * Formato: /necrologi/{provincia}/{nome-cognome-id}
 */

/**
 * Normalizza una stringa per uso in URL (slug)
 * @param {string} text - Testo da normalizzare
 * @returns {string} - Slug URL-safe
 */
export const normalizeForSlug = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Rimuove accenti
    .replace(/[^a-z0-9]+/g, '-')     // Sostituisce caratteri speciali con -
    .replace(/^-+|-+$/g, '');        // Rimuove - iniziali e finali
};

/**
 * Genera l'URL SEO-friendly per un necrologio
 * @param {Object} necrologio - Oggetto necrologio con campi: slug, provincia, comune, id
 * @returns {string} - URL nel formato /necrologi/{provincia}/{slug} o fallback /necrologio/{id}
 */
export const getNecrologioUrl = (necrologio) => {
  if (!necrologio) return '/necrologi';
  
  // Se ha lo slug, usa il nuovo formato SEO-friendly
  if (necrologio.slug) {
    const provincia = normalizeForSlug(necrologio.provincia || necrologio.comune || 'italia');
    return `/necrologi/${provincia}/${necrologio.slug}`;
  }
  
  // Fallback al vecchio formato con UUID
  return `/necrologio/${necrologio.id}`;
};

/**
 * Genera l'URL per la candela di un necrologio
 * @param {Object} necrologio - Oggetto necrologio
 * @returns {string} - URL per la pagina candela
 */
export const getCandleUrl = (necrologio) => {
  if (!necrologio) return '/';
  return `/necrologio/${necrologio.id}/candela`;
};

/**
 * Genera l'URL completo (con dominio) per condivisione
 * @param {Object} necrologio - Oggetto necrologio
 * @returns {string} - URL completo
 */
export const getShareUrl = (necrologio) => {
  return `${window.location.origin}${getNecrologioUrl(necrologio)}`;
};

export default {
  normalizeForSlug,
  getNecrologioUrl,
  getCandleUrl,
  getShareUrl
};
